module.exports = __webpack_public_path__ + "static/parteaguas-376a7acf89f4f6eccb24968360327c5d.svg";